export default "__VITE_ASSET__BcumjotM__"